module.exports = __webpack_public_path__ + "static/media/img-background3.c3f76aed.jpg";